// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form_description[data-v-4ef0e4de]{font-size:12px;color:#aaa;max-width:700px}", ""]);
// Exports
module.exports = exports;
